import { render, staticRenderFns } from "./ProfilePublicProjectsView.vue?vue&type=template&id=37e54b18&scoped=true"
import script from "./ProfilePublicProjectsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfilePublicProjectsView.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfilePublicProjectsView.vue?vue&type=style&index=0&id=37e54b18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e54b18",
  null
  
)

export default component.exports